import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { ProcessTimeline, Philosophy, CtaBand } from "@/components/site/Sections";
import { ASSESSMENT, IMAGES } from "@/components/site/data";

export default function Procurement() {
  return (
    <>
      <PageHero overline="International Procurement" title="A Structured Approach to Global Sourcing." image={IMAGES.trade}>
        <p>
          RSC Imports follows a structured procurement and market-development process designed to
          identify commercially viable long-term opportunities.
        </p>
      </PageHero>

      <ProcessTimeline showHeader={false} />

      <section data-testid="assessment-section" className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <Reveal>
            <p className="text-xs md:text-sm uppercase tracking-[0.25em] font-semibold text-[#BFA26F] mb-4" data-testid="overline-assessment-criteria">
              Commercial Assessment Criteria
            </p>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-medium leading-tight text-[#111413] max-w-3xl mb-14">
              How Opportunities Are Assessed.
            </h2>
          </Reveal>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-t border-l border-[#0D2B1E]/10" data-testid="assessment-grid">
            {ASSESSMENT.map((a, i) => (
              <Reveal key={a} delay={i * 0.04} className="border-b border-r border-[#0D2B1E]/10">
                <div className="p-6 md:p-8 h-full bg-[#FBF9F6]/60 hover:bg-[#FBF9F6] transition-colors duration-300 flex items-start gap-4">
                  <span className="mt-1.5 h-1 w-4 bg-[#BFA26F] shrink-0" />
                  <p className="text-sm font-medium tracking-wide text-[#111413] uppercase">{a}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Philosophy />

      <CtaBand
        title="Start the Procurement Conversation."
        text="Introduce your company and products to our international procurement team."
        buttonLabel="Submit to Procurement"
        to="/partner"
      />
    </>
  );
}
